import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useLanguageCode, useUnlocalizedPath } from './index';
import { Helmet } from 'react-helmet';
import { useGlue } from '../hooks';
export const TranslatedLayout = () => {
    const [languageCode, setLanguageCode] = useLanguageCode();
    const unlocalizedPath = useUnlocalizedPath();
    const glue = useGlue();
    // We are in translated layout, we are sure that language is present in URL
    const lang = useLocation().pathname.split('/')[1];
    useEffect(() => {
        if (lang !== languageCode && setLanguageCode) {
            setLanguageCode(lang);
        }
    }, [lang, setLanguageCode, languageCode]);
    //Avoid rendering if it's not good language
    if (lang !== languageCode) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null, glue.frontAvailableLanguages.map((langHref) => (React.createElement("link", { rel: 'alternate', key: langHref, hrefLang: langHref, href: window.location.origin + '/' + langHref + unlocalizedPath })))),
        React.createElement(Outlet, null)));
};
//# sourceMappingURL=TranslatedLayout.js.map